import Tracked from 'editor/utils/Tracked';

type ScreenCoordinateArgs = {
  topLeft: mapboxgl.PointLike;
  bottomRight: mapboxgl.PointLike;
  bearing: number;
};

type Camera = {
  viewport?: Viewport;
  screenCoordinates?: ScreenCoordinateArgs;
  locked: boolean;
  fitToBounds?: {
    bounds: Bounds;
    padding: { top: number; bottom: number; left: number; right: number };
  };
};

class MapboxCamera extends Tracked<Camera> {
  updated = new Set<string>();

  constructor(viewport: Viewport) {
    super({
      viewport,
      locked: false,
    });

    this.tracked.viewport = viewport;
    this.tracked.locked = false;
  }

  didUpdate(updatedField: string): void {
    this.updated.add(updatedField);
  }
}

export default MapboxCamera;
